import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import ThemeProvider from "./utils/ThemeContext";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/react";
import config from "@/config";
import { GoogleMapsProvider } from "./utils/googleMaps.jsx";

if (config.environment !== "local" && config.environment !== "local-ip") {
  Sentry.init({
    dsn: "https://2007f264d1de74387369c8cfe5514461@o4510167252074496.ingest.us.sentry.io/4510167253909504",
    sendDefaultPii: true,
  });
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <Provider store={store}>
    <Router>
      <ThemeProvider>
        <GoogleMapsProvider>
          <App />
        </GoogleMapsProvider>
      </ThemeProvider>
    </Router>
  </Provider>
);
